exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.legend-helper[data-v-13cabf4c] {\n    position: absolute;\n    left: -20px;\n}\n@media print{\n    /*@page {\n        size: landscape;\n    }*/\n#highcharts-canvas[data-v-13cabf4c] {\n        width: 2300;\n}\n.card[data-v-13cabf4c] {\n        background-color: transparent;\n        border: none;\n}\n}\n", ""]);

// exports
